import { AutoTimingStrategy } from '@/renderer/scripts/CoSync/SyncCenter/ServiceMgr/TimingStrategy/AutoTimingStrategy';
import { ITimingStrategy } from '@/renderer/scripts/CoSync/SyncCenter/ServiceMgr/TimingStrategy/ITimingStrategy';
import { ManulTimingStrategy } from '@/renderer/scripts/CoSync/SyncCenter/ServiceMgr/TimingStrategy/ManulTimingStrategy';
import { TimingStrategyDelegate } from '@/renderer/scripts/CoSync/SyncCenter/ServiceMgr/TimingStrategy/TimingStrategyDelegate';
import { CoSyncInfo, CoSyncTimingType } from '@/workerProcessRenderer/scripts/CoSyncEngine/common/CoSyncConfig';

export class TimingStrategyFactory {
  public static createTimingStrategyFrom(
    servceDelegate: WeakRef<TimingStrategyDelegate>,
    coSyncInfo: CoSyncInfo,
  ): ITimingStrategy {
    switch (coSyncInfo.config.syncSetting.timingType) {
      case CoSyncTimingType.MANUL:
        return new ManulTimingStrategy(servceDelegate, coSyncInfo);

      case CoSyncTimingType.AUTO:
        return new AutoTimingStrategy(servceDelegate, coSyncInfo);

      case CoSyncTimingType.TIMIING:
        throw { code: 'TimingTypeNotSupported' };
    }
  }
}
